import {
  chatLastMessageUpdate,
  clearChatRoomTotalUndelivered,
  deleteMessage,
  restoreChatRoom,
  searchChatMessage,
  setDeleteMessageError,
  setDialogs,
  setEditMessageError,
  setGlobalUndelivered,
  setMessages,
  setNewMessage,
  setNextPageMessages,
  updateMessage,
} from '../redux/actions/chat.action'
import {
  newSupportMessageAction,
  setSupportUndelivered,
  updateSupportMessages,
  resetTotalUndelivered,
  setSupportStatus,
  setNextPageMessagesSupport,
  deleteSupportMessage,
  updateSupportMessage,
  setSupportEditMessageError,
  setSupportDeleteMessageError,
  searchSupportMessage,
  setAnonymousId,
} from '../redux/support/support.action'
import { notify } from '../helpers/notify'

import {
  deleteVacancyRequest,
  setIdDeletedUser,
  setNewVacancyRequest,
  setVacancyRequestCount,
  updateVacancyRequest,
} from '../redux/actions/seafarersSearch'
import { setBillingPermissions, updateCompanyInfo } from '../redux/actions/company.action'
import { companyInformationHelper } from '../helpers/companyInformation.helper'
import { profilePaths, events } from '../constants/constants'
import { getProfileFetch } from '../redux/actions/user.action'
import { userLogout } from '../redux/actions/auth'
import { popupNotifyText } from '../components/Store/Services/constants'
import { getRefreshToken, getToken } from '../api/auth.service'
import { setToken } from '../redux/actions/user.action'
import { isExpired } from '../api/auth.service'
import Cookies from 'js-cookie'
import Socket from './index'
import { urlProvider } from './index'
import { setSurveyStatusAction, setSurveyVacancyAction } from '../redux/actions/ui.action'
import { setSurveyDataAction } from '../redux/actions/ui.action'

export const socketEvent = (event, payload) => (dispatch, useSelector) => {
  let isRefreshing = false
  if (
    window.location.href.includes('dev') ||
    window.location.href.includes('localhost') ||
    window.location.href.includes('stage')
  ) {
    console.log('%c%s', 'color: #43927C;', event, payload)
  }

  switch (event) {
    // information about the company
    case 'company.moderation_state.registered.remove':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      break

    case 'company.moderation_state.registered.add':
      notify.info('Info', 'Your company has been sent for remoderation', {})
      dispatch(getProfileFetch())
      break

    case 'company.moderation_state.update':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      dispatch(getProfileFetch())
      break

    case 'company.moderation_state.accepted.add':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      break

    case 'company.moderation_state.moderation':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      dispatch(getProfileFetch())
      notify.info('Info', 'Your company has successfully passed moderation')

      break

    case 'company.moderation_state.accepted.remove':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      break

    case 'company.moderation_state.rejected.add':
      dispatch(updateCompanyInfo(companyInformationHelper(payload)))
      notify.info('Info', 'Your company was rejected')
      dispatch(userLogout())
      break

    // vacancy request cases
    case 'company.vacancy_request.count':
      dispatch(setVacancyRequestCount(payload))
      break

    case 'company.vacancy_request.created':
      const selector = useSelector()
      const userId = selector.user.profile.id
      const candidate = selector.seafarersSearch.requestFilter.candidates

      if (candidate !== 'my') {
        dispatch(setNewVacancyRequest(payload))
        dispatch(setVacancyRequestCount(payload))
      } else if (
        payload.vacancy.vacancy.created_by_company_user === userId ||
        payload.vacancy.vacancy.created_by_company_user === null
      ) {
        dispatch(setNewVacancyRequest(payload))
        dispatch(setVacancyRequestCount(payload))
      }

      break

    case 'company.vacancy_request.deleted':
      dispatch(deleteVacancyRequest(payload))
      break

    case 'company.vacancy_request.viewed':
      dispatch(updateVacancyRequest(payload))

      break

    // seafarer cases
    case 'seafarer_actions.seafarer.deleted':
      dispatch(setIdDeletedUser(payload.user_id))
      break

    // main chat cases
    case 'chat.rooms':
      dispatch(setDialogs(payload))
      break

    case 'chat.messages':
      // if payload has last_message_id, call setNextPageMessages
      if (payload.last_message_id) {
        dispatch(setNextPageMessages(payload))
      } else {
        dispatch(setMessages(payload))
      }

      break

    case 'new.chat.message':
      dispatch(setNewMessage(payload))
      break

    case 'chat.message.deleted':
      dispatch(deleteMessage(payload.chat_id, payload.id, payload.total_undelivered))
      break

    case 'chat.message.updated':
      dispatch(updateMessage(payload))
      break

    case 'chat.total.undelivered':
      dispatch(setGlobalUndelivered(payload))
      dispatch(setSupportUndelivered(payload.support))
      break

    case 'chat.room.auto.restore':
      dispatch(restoreChatRoom(payload))
      break

    case 'no.chat.messages':
      window.location.href = `${profilePaths.chat}`
      break

    case 'chat.message.was.delivered':
      dispatch(clearChatRoomTotalUndelivered(payload))
      break

    case 'chat.last.message.update':
      dispatch(chatLastMessageUpdate(payload))
      break

    case 'error.message':
      notify.error('Error', payload.message)
      break

    case 'error.chat.edit.message':
      dispatch(setEditMessageError(payload.message))
      break

    case 'error.chat.delete.message':
      dispatch(setDeleteMessageError(payload.message))
      break

    case 'search.chat.message':
      dispatch(searchChatMessage(payload))
      break

    //  support chat cases
    case 'support.messages':
      if (payload.last_message_id) {
        dispatch(setNextPageMessagesSupport(payload))
      } else {
        dispatch(updateSupportMessages(payload))
      }

      break

    case 'support.new.chat.message':
      dispatch(newSupportMessageAction(payload))
      break

    case 'support.chat.message.was.delivered':
      dispatch(resetTotalUndelivered(payload))
      break

    case 'support.chat.status':
      dispatch(setSupportStatus(payload))
      break

    case 'support.chat.message.deleted':
      dispatch(deleteSupportMessage(payload.id))
      break

    case 'support.chat.message.updated':
      dispatch(updateSupportMessage(payload))
      break

    case 'error.support.chat.edit.message':
      dispatch(setSupportEditMessageError(payload.message))
      break

    case 'error.support.chat.delete.message':
      dispatch(setSupportDeleteMessageError(payload.message))
      break

    case 'search.support.message':
      dispatch(searchSupportMessage(payload))
      break

    case 'anonymous.uuid':
      dispatch(setAnonymousId(payload.uuid))
      break

    // billing cases
    case events.billing.permissionsCurrent:
      dispatch(setBillingPermissions(payload))
      break
    case events.billing.permissionsUpdated:
      dispatch(setBillingPermissions(payload))
      break
    case events.billing.subscriptionPaid:
      if (window.location.href.indexOf('profile/billing') === -1) {
        notify.info('Info', popupNotifyText.success)
      }
      break
    case events.billing.subscriptionUnPaid:
      if (window.location.href.indexOf('profile/billing') === -1) {
        notify.info('Info', popupNotifyText.unSuccess)
      }
      break
    case events.billing.subscriptionCanceled:
      notify.info('Info', 'Your subscription has been canceled!')
      break
    // error case
    case 'error': {
      notify.error('Error', payload.message)
      if (payload.message === 'Authorization for company failed') {
        const token = JSON.parse(localStorage.getItem('user'))

        if (!token || !token.refresh_token || isRefreshing) {
          break
        }

        if (isExpired(token.expires_date)) {
          isRefreshing = true

          getRefreshToken(token.refresh_token)
            .then((newTokens) => {
              if (newTokens.ok && newTokens.access_token) {
                const expiresIn = newTokens.expires_in || 3600
                const expiresDate = Date.now() + expiresIn * 1000

                const updatedTokens = {
                  ...newTokens,
                  expires_date: expiresDate,
                }

                dispatch(setToken(updatedTokens))
                Cookies.set('token', updatedTokens.access_token, { path: '/' })
                localStorage.setItem('user', JSON.stringify(updatedTokens))

                const newUrl = urlProvider()
                Socket.url = newUrl

                Socket.close()
                setTimeout(() => {
                  Socket.reconnect()
                }, 300)
              } else {
                console.warn('Failed to refresh the token')
              }
            })
            .catch((error) => {
              // console.error('Error:', error)
            })
            .finally(() => {
              isRefreshing = false
            })
        } else {
          console.warn('⚠️ The token has not expired yet, but authorization failed.')
        }
      }
      break
    }

    // company survey
    case 'connection.status':
      const currentState = useSelector()
      const surveyData = currentState?.ui?.surveyData

      if (surveyData && Array.isArray(surveyData) && surveyData.length > 0) {
        dispatch(setSurveyStatusAction(true))

        if (Socket.isReady) {
          Socket.emit('company_survey.get_survey', {
            vacancy_id: surveyData[0],
          })
        }
      }
      break

    case events.company_survey.list:
      const urlParams = new URLSearchParams(window.location.search)
      const surveyParam = urlParams.get('survey')
      const hasSurveys = payload.surveys && payload.surveys.length > 0

      if (surveyParam === 'true') {
        dispatch(setSurveyStatusAction(true))

        if (hasSurveys) {
          dispatch(setSurveyDataAction(payload.surveys))
          if (Socket.isReady) {
            Socket.emit('company_survey.get_survey', {
              vacancy_id: payload.surveys[0],
            })
          }
        } else {
          dispatch(setSurveyDataAction({ no_surveys_found: true }))
        }
      } else {
        dispatch(setSurveyStatusAction(hasSurveys))
        if (hasSurveys) {
          dispatch(setSurveyDataAction(payload.surveys))

          if (Socket.isReady) {
            Socket.emit('company_survey.get_survey', {
              vacancy_id: payload.surveys[0],
            })
          }
        }
      }

      break

    case events.company_survey.get_survey:
      if (payload && payload.vacancy_offers) {
        dispatch(setSurveyVacancyAction(payload))
      }

      break

    // case events.company_survey.closed:
    //   dispatch(setSurveyStatusAction(false))

    //   break

    case events.company_survey.opened:
      if (!!payload.vacancy_id) dispatch(setSurveyStatusAction(true))

      if (Socket.isReady) {
        Socket.emit('company_survey.get_survey', { vacancy_id: payload.vacancy_id })
      }
      break

    case events.company_survey.select_seafarers:
      break

    case 'company_survey.list_after_closing': {
      const hasSurveys = payload.surveys && payload.surveys.length > 0
      const state = useSelector()
      const currentStep = state.ui.currentStep

      dispatch(setSurveyDataAction(payload.surveys))

      if (hasSurveys) {
        dispatch(setSurveyStatusAction(hasSurveys))

        Socket.emit('company_survey.get_survey', {
          vacancy_id: payload.surveys[0],
        })
      } else {
        if (currentStep !== 2 && document.visibilityState !== 'visible') dispatch(setSurveyStatusAction(false))
      }
      break
    }

    case 'company_survey.list_after_opening': {
      const hasSurveys = payload.surveys && payload.surveys.length > 0
      const state = useSelector()
      const currentStep = state.ui.currentStep
      dispatch(setSurveyDataAction(payload.surveys))
      if (hasSurveys) {
        dispatch(setSurveyStatusAction(hasSurveys))
        Socket.emit('company_survey.get_survey', {
          vacancy_id: payload.surveys[0],
        })
      } else {
        if (currentStep !== 2 && document.visibilityState !== 'visible') dispatch(setSurveyStatusAction(false))
      }
      break
    }

    default:
      return
  }
}
